// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2yDZs","content":"GlobalSearch_content__1MZ-Q"};